module.exports = __webpack_public_path__ + "img/chest_hover.21480245.png";